{
  "name": "taas-portal-frontend",
  "version": "0.7.9",
  "scripts": {
    "ng": "ng",
    "lint": "ng lint",
    "test": "ng test --watch=false",
    "start": "ng serve",
    "start-prod": "ng serve --configuration production",
    "start-preprod": "ng serve --configuration preprod",
    "start-de": "ng serve --configuration=de",
    "start-en": "ng serve --configuration=en",
    "start-sv": "ng serve --configuration=sv",
    "translate": "ng extract-i18n",
    "build": "ng build",
    "build:stats": "ng build --stats-json && esbuild-visualizer --metadata ./dist/taas-portal-frontend/stats.json --filename ./dist/taas-portal-frontend/stats.html && open-cli ./dist/taas-portal-frontend/stats.html",
    "build-prod": "ng build --configuration production",
    "build-preprod": "ng build --configuration preprod",
    "build-dev": "ng build --configuration development",
    "watch": "ng build --watch --configuration development"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.1.5",
    "@angular/cdk": "^21.1.5",
    "@angular/common": "^21.1.5",
    "@angular/compiler": "^21.1.5",
    "@angular/core": "^21.1.5",
    "@angular/forms": "^21.1.5",
    "@angular/material": "^21.1.5",
    "@angular/platform-browser": "^21.1.5",
    "@angular/platform-browser-dynamic": "^21.1.5",
    "@angular/router": "^21.1.5",
    "jwt-decode": "^4.0.0",
    "keycloak-angular": "^21.0.0",
    "keycloak-js": "^26.2.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.8.1",
    "utimaco-common-ui-angular": "https://repo.fra1.us.utimaco.cloud/repository/npm-hosted/utimaco-common-ui-angular/-/utimaco-common-ui-angular-1.20.0.tgz",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.2.0",
    "@angular-eslint/eslint-plugin": "^21.2.0",
    "@angular-eslint/eslint-plugin-template": "^21.2.0",
    "@angular-eslint/schematics": "^21.2.0",
    "@angular-eslint/template-parser": "^21.2.0",
    "@angular/build": "^21.1.5",
    "@angular/cli": "^21.1.5",
    "@angular/compiler-cli": "^21.1.5",
    "@angular/localize": "^21.1.5",
    "@typescript-eslint/eslint-plugin": "^8.33.1",
    "@typescript-eslint/parser": "^8.33.1",
    "esbuild-visualizer": "^0.7.0",
    "eslint": "^9.39.3",
    "jsdom": "^29.1.1",
    "ng-extract-i18n-merge": "^3.3.0",
    "open-cli": "^8.0.0",
    "typescript": "~5.9.3",
    "vitest": "^4.1.6"
  },
  "overrides": {
    "tar": "7.5.8"
  },
  "overridesNote": "TODO: remove tar override once @angular/cli/pacote updates tar >=7.5.7"
}
